import React from 'react'
import Image from 'next/image'
import {
  PortableText,
  PortableTextListComponent,
  PortableTextListItemComponent,
} from '@portabletext/react'

import { blockSerializers } from './index'
import { CompareCredit } from '../../../types/compare-credit'
import cn from 'utils/classnames'
import { useShouldShowNewTFHDesign } from 'utils/experimentation/useShouldShowNewTFHDesign'

const List: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ul className="c-list-disc / mb-2 pl-5">{children}</ul>
)

const ListItem: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <li className={`c-list-disc__item`}>
      {children}{' '}
      <style jsx>
        {`
          .c-list-disc__item {
            margin-bottom: 0.25em;
          }
          .c-list-disc__item:last-child {
            margin-bottom: 0;
          }
        `}
      </style>
    </li>
  )
}

export const ContentHighlight = ({
  cardOrderIds,
  referencedCards,
  categoryId,
  externalId,
}: {
  cardOrderIds: Record<string, string>
  referencedCards: null | Record<string, CompareCredit.Entity>
  categoryId: string
  externalId: string
}) => {
  const ContentHighlightRender: React.FC<{
    value: {
      title: string
      contentClass?: string
      border: boolean
      layoutDesktop?: boolean
      bgColor?: string
      content: any
    }
  }> = ({
    value: { title, contentClass, border, layoutDesktop, bgColor, content },
  }) => {
    const newTfhDesign = useShouldShowNewTFHDesign()

    return (
      <div
        className={cn(`c-content-highight flex gap-2`, {
          [`${contentClass}`]: contentClass,
          'bg-[#FEFAEE]': bgColor === 'light-orange',
          'bg-primary-light-bg': bgColor !== 'light-orange',
          'mb-3 p-3 rounded-sm': layoutDesktop,
          'mb-6 p-4 xxs:px-6 xxs:py-5 rounded': !layoutDesktop,
          'rounded border border-tetriary leading-snug': newTfhDesign,
        })}
      >
        {newTfhDesign && (
          <div className="relative flex-none self-start w-7 h-7">
            <Image
              fill
              src="/static/icons/icon-zero-calendar-primary-bright.svg"
              alt="zero calendar"
              className="object-contain"
            />
          </div>
        )}
        <div>
          <h3
            className={cn(
              `c-content-highight__title / mb-2 text-primary font-bold leading-snug`,
              {
                'font-serif text-2xl xs:text-3xl': !layoutDesktop,
              },
            )}
          >
            {title}
          </h3>
          {border ? (
            <hr className="c-content-highight__border / w-24 xs:w-28 / border-3 border-tetriary / my-3" />
          ) : null}
          <div className="c-content-highight__content">
            <PortableText
              value={content}
              components={{
                ...blockSerializers({
                  cardOrderIds,
                  categoryId,
                  externalId,
                  referencedCards,
                }),
                list: List as PortableTextListComponent,
                listItem: ListItem as PortableTextListItemComponent,
              }}
            />
          </div>
        </div>
      </div>
    )
  }
  return ContentHighlightRender
}
